import { CompactUser } from "../../../core/CompactModels"
import { HereGeocodeItem } from "../../../models/MapModels"
import PhoneItem from "../../../models/PhoneItem"



export default interface WarehouseContainerModel {
    id?: string
    name?: string
    containerID?: string
    description?: string

    address?: HereGeocodeItem

    managerName?: string
    managerPhone?: PhoneItem
    managerPhoneRaw?: string

    containerType?: WarehouseContainerTypes
    containerTypeText?: string
    operatinalStatus?: WarehouseContainerStatus
    storageCapacity?: string

    mapZoom?: number

    creatorUserId?: string
    creatorUser?: CompactUser
    modifiedUserId?: string
    modifiedUser?: CompactUser
    createdAt?: Date
    modifiedAt?: Date

}

export interface WarehouseContainerCompact {
    id?: string
    name?: string
    containerID?: string
}

export interface ContainerRequestModel {
    id?: string
    name?: string
    description?: string
    countryId?: string
    addressText?: string
    addressId?: string
    managerName?: string
    managerPhone?: PhoneItem
    storageCapacity?: string
    containerType?: WarehouseContainerTypes
    containerStatus?: WarehouseContainerStatus
    mapZoom?: number
}

export enum WarehouseContainerTypes {
    None = 0,
    DistributionCenter = 1,
    StorageFacility = 2,
    RetailOutlet = 3,
    MobileUnit = 4
}

export enum WarehouseContainerStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    UnderMaintenance = 3
}